import omit from "lodash/omit";

import {
  ADD_SERVICE_FAILED,
  ADD_SERVICE_START,
  ADD_SERVICE_SUCCESS,
  ADD_SERVICE_WITH_ADMIN_FAILED,
  ADD_SERVICE_WITH_ADMIN_START,
  ADD_SERVICE_WITH_ADMIN_SUCCESS,
  REGISTER_SERVICE_FAILED,
  REGISTER_SERVICE_START,
  REGISTER_SERVICE_SUCCESS,
  REMOVE_SERVICE_FAILED,
  REMOVE_SERVICE_START,
  REMOVE_SERVICE_SUCCESS,
  SET_CURRENT_SERVICE,
  SET_SERVICES_FILTER_TERM
} from "../constants";

const servicesMainReducer = (state, action) => {
  switch (action.type) {
    case SET_CURRENT_SERVICE:
      return {
        ...state,
        current: action.uri
      };
    case SET_SERVICES_FILTER_TERM:
      return {
        ...state,
        filterTerm: action.filterTerm
      };
    case ADD_SERVICE_START:
      return {
        ...state,
        saving: true
      };
    case ADD_SERVICE_SUCCESS:
      return omit(
        {
          ...state,
          saving: false
        },
        ["errorDescription", "error"]
      );
    case ADD_SERVICE_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        saving: false
      };
    case ADD_SERVICE_WITH_ADMIN_START:
      return {
        ...state,
        savingWithAdmin: true
      };
    case ADD_SERVICE_WITH_ADMIN_SUCCESS:
      return omit(
        {
          ...state,
          savingWithAdmin: false
        },
        ["errorDescription", "error"]
      );
    case ADD_SERVICE_WITH_ADMIN_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        savingWithAdmin: false
      };
    case REMOVE_SERVICE_START:
      return {
        ...state,
        saving: true
      };
    case REMOVE_SERVICE_SUCCESS:
      return omit(
        {
          ...state,
          saving: false,
          items: state.items.filter(
            service => service.$uri !== action.service.$uri
          )
        },
        ["errorDescription", "error"]
      );
    case REMOVE_SERVICE_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        saving: false
      };
    case REGISTER_SERVICE_START:
      return {
        ...state,
        saving: true,
        items: state.items.map(service => {
          if (action.service.$uri === service.$uri) {
            return {
              ...service,
              credentials: {
                key: action.keyPair
              }
            };
          }
          return service;
        })
      };
    case REGISTER_SERVICE_SUCCESS:
      return omit(
        {
          ...state,
          saving: false,
          items: state.items.map(service => {
            if (action.service.$uri === service.$uri) {
              return {
                ...service,
                pending: false,
                credentials: {
                  ...service.credentials,
                  agents: [action.response]
                }
              };
            }
            return service;
          })
        },
        ["errorDescription", "error"]
      );
    case REGISTER_SERVICE_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        saving: false
      };
    default:
      return state;
  }
};

export default servicesMainReducer;
